import { render, staticRenderFns } from "./invoice-table.vue?vue&type=template&id=8345bda6&scoped=true&"
import script from "./invoice-table.vue?vue&type=script&lang=js&"
export * from "./invoice-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8345bda6",
  null
  
)

export default component.exports